import React, { useState, useEffect, useRef } from "react";
import { InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFunnelDollar } from '@fortawesome/free-solid-svg-icons'
import { useAlert } from "react-alert";

const EditableCell = ({
  value: initialValue,
  row: { index, original },
  column: { id },
  updateMyData,
  customeUpdateCallback,
  isNumeric = false,
  isDouble = false,
  addInitialValue = false,
  maximumToShow = 0,
  maximumLimit = 0,
  isPrice = false,
  ignoreMaximumLimit = false,
  disabled = false,
}) => {
  const [value, setValue] = useState((isDouble ? (initialValue ? Number(initialValue.toFixed(2)) : 0) : initialValue) || (isDouble || isNumeric ? 0 : ""));
  const valueRef = useRef<HTMLInputElement>(document.createElement("input"));
  const [didFirstInputUpdate, setDidFirstInputUpdate] = useState(false);
  const [color, setColor] = useState("");
  const alert = useAlert();

  const onChange = (e) => {
    const valueTemp = e.target.value;
    if(isNumeric){
      const re = /^[0-9\b]+$/;
      if(re.test(e.target.value) && +e.target.value >= 1){
        if(!addInitialValue || +e.target.value <= original.QTE_INIT_TABLE){
          setValue(+e.target.value);
          setColor("");
        }
        else{
          if(ignoreMaximumLimit){
            setValue(+e.target.value);
            setColor("red");
          }
          else
            alert.info(`Maximum autorisé: ${original.QTE_INIT_TABLE}`);
        }
      }
      else
        alert.error(`${valueTemp} n'est pas un nombre valide`);
    }
    else if(isDouble){
      const doubleValue = e.target.value ? e.target.value.toString().replace(",", ".") : 0,
        splits = doubleValue.toString().split(".");
      if((!isNaN(doubleValue)/* && +doubleValue > 0*/) || doubleValue === "0."){
        if(!addInitialValue || +doubleValue <= maximumLimit){
          setValue(splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue);
          setColor("");
        }
        else{
          if(ignoreMaximumLimit){
            setValue(splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue);
            setColor("red");
          }
          else
            alert.info(`Maximum autorisé: ${maximumLimit.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH`);
        }
      }
      else if(e.target.value === ""){
        setValue(0);
      }
      else{
        alert.error(`${valueTemp} n'est pas un nombre valide`);
        setValue(value);
      }
    }
    else
      setValue(e.target.value || "");
  };

  // useEffect(() => { ??? ti tfocusa w ti updater li fih 0 f goal w budget
  //   if(!didFirstInputUpdate)
  //     setDidFirstInputUpdate(true)
  //   else if(value === 0 && valueRef?.current)
  //     valueRef.current.select()
  // }, [value]);

  const onBlur = () => {
    if(!customeUpdateCallback)
      updateMyData(index, id, isNumeric || isDouble ? +value : value)
    else
      customeUpdateCallback(original, id, isNumeric || isDouble ? +value : value)
  };

  const onFocus = (e) => {
    if((isDouble || isNumeric) && e.target.value == "0")
      e.target.select();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.target.blur();
    }
  }

  // React.useEffect(() => {
  // }, [value]);

  useEffect(() => {
    setValue((isDouble ? (initialValue ? Number(initialValue.toFixed(2)) : 0) : initialValue) || (isDouble || isNumeric ? 0 : ""));
  }, [initialValue]);

  // return <input type={isNumeric ? "number" : "text"} pattern={isNumeric ? "[0-9]*" : ""} className="editableCell form-control" value={value} onChange={onChange} onBlur={onBlur} />;
  return addInitialValue ? (
    <InputGroup className={isPrice ? "editableCellPrice" : "editableCell"}>
      <Input type={isNumeric ? "number" : "text"} innerRef={valueRef} disabled={!!disabled} tabindex={Number(index || 0) + 1} pattern={isNumeric ? "[0-9]*" : undefined} className="form-control" style={color ? {color: color} : {}} value={value} onChange={onChange} onBlur={onBlur} onFocus={onFocus} onKeyDown={handleKeyDown} />
      <InputGroupAddon addonType="append">
        <InputGroupText>({isDouble ? (maximumToShow ? maximumToShow.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (isPrice ? " Dh" : "") : "-") : (original.QTE_INIT || "-")})</InputGroupText>
      </InputGroupAddon>
    </InputGroup>
  ) : isDouble ? (
    <InputGroup className={isPrice ? "editableCellPrice" : "editableCell"}>
      <Input type="text" innerRef={valueRef} disabled={!!disabled} tabindex={Number(index || 0) + 1} className="form-control" value={value} onChange={onChange} onBlur={onBlur} onFocus={onFocus} onKeyDown={handleKeyDown} />
      {!!isPrice && <InputGroupAddon addonType="append">
        <InputGroupText>DH</InputGroupText>
      </InputGroupAddon>}
    </InputGroup>
  ) : <input type={isNumeric ? "number" : "text"} ref={valueRef} disabled={!!disabled} tabIndex={Number(index || 0) + 1} pattern={isNumeric ? "[0-9]*" : undefined} className="editableCellInput form-control" style={color ? {color: color} : {}} value={value} onChange={onChange} onBlur={onBlur} onFocus={onFocus} onKeyDown={handleKeyDown} />
};

export default EditableCell;
